var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifyBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5754",
    "data-name": "Group 5754",
    transform: "translate(-1063 -112)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_261",
    "data-name": "Ellipse 261",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(1063 112)",
    fill: "#ff009e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "alarm",
    d: "M21.106,18.084l-.682-1.071A1.169,1.169,0,0,1,20.2,16.3V9.318a6.745,6.745,0,0,0-2.305-5.065,7.868,7.868,0,0,0-4.675-1.948V1.461a.584.584,0,1,0-1.169,0v.812c-.13,0-.26.032-.39.032A7.343,7.343,0,0,0,5,9.416V16.3a1.705,1.705,0,0,1-.195.682l-.649,1.1a.849.849,0,0,0,0,.877.859.859,0,0,0,.747.422h7.143v.909a.584.584,0,1,0,1.169,0v-.909h7.143a.859.859,0,0,0,.747-.422A.849.849,0,0,0,21.106,18.084Zm-15.714.162.422-.682a2.921,2.921,0,0,0,.325-1.136V9.448a6.165,6.165,0,0,1,5.649-5.974A6.816,6.816,0,0,1,17.112,5.13,5.624,5.624,0,0,1,19.06,9.351v7.013a2.529,2.529,0,0,0,.39,1.331l.39.617H5.392Z",
    transform: "translate(1074.367 125.123)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyBell);
export default __webpack_public_path__ + "static/media/notify-bell.9156bf27ccb86de2af3d2aaa2776b6e6.svg";
export { ForwardRef as ReactComponent };